'use es6';

import { createSelector } from 'reselect';
import { selectAllLimits } from './index';
export const selectLimit = limitName => createSelector(selectAllLimits, limitsList => limitsList.get(limitName));
export const selectCustomReportsLimit = selectLimit('custom-reports');
export const selectStandardReportsLimit = selectLimit('standard-reports');
export const selectDashboardMaxWidgetsLimit = createSelector(selectAllLimits, limitsList => limitsList.get('dashboard-max-widgets') || 0);
export const selectReportingIncreaseCountLimit = createSelector(selectAllLimits, limitsList => limitsList.get('reporting-increase-count') || 0);
export const selectDashboardLimit = createSelector(selectAllLimits, limitsList => limitsList.get('dashboards') || 0);